<template>
  <div>
    <common-dialog
      ref="dialog"
      width="400px"
      show-save-button
      unit="餐次"
      edit-title
      id-key="MealId"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="餐次名称" prop="MealName">
          <el-input v-model="data.MealName" placeholder="请输入餐次名称"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="StartTime">
          <el-time-picker
            v-model="data.StartTime"
            value-format="HH:mm"
            format="HH:mm"
            placeholder="请选择开始时间"
          ></el-time-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="EndTime">
          <el-time-picker
            v-model="data.EndTime"
            value-format="HH:mm"
            format="HH:mm"
            placeholder="请选择结束时间"
          ></el-time-picker>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        MealId: 0,
        MealName: "",
        StartTime: "",
        EndTime: "",
      },
      api: require("@/api/cp/meal").default,
      rules: {
        MealName: [{ required: true, message: "餐次名称不能为空" }],
        StartTime: [{ required: true, message: "开始时间不能为空" }],
        EndTime: [{ required: true, message: "结束时间不能为空" }],
      },
    };
  },
  computed: {},
  methods: {},
};
</script>